




































import {Component, Prop, Vue, Watch} from "vue-property-decorator";
import Keyword from "@/components/Keyword.vue";
import {bus} from "@/plugins/bus";
import {localStorageService} from "@/services/local-storage.service";
import {LocalStorageServiceConfig} from "@/interfaces/local-storage.interface";
import {RouterStore} from "@/interfaces/store-interfaces/router-store.interface";

@Component({
  components: {
    Keyword
  }
})

export default class HistoryMenu extends Vue {
  baseUrl = process.env.VUE_APP_PUBLIC_URL;
  historyMenuVisible = false;
  itemTypes = LocalStorageServiceConfig.HistoryItemTypes;
  historyList: LocalStorageServiceConfig.IHistoryItem[] = [];
  routePath = RouterStore.ROUTE_PATH;

  get isMenuOpen() {
    let menuOpen = this.$store.state.dialog.menu;
    if (menuOpen) {
      return this.historyMenuVisible = false;
    }
  }

  get isKiosk() {
    return this.$store.state.rhizome.kioskMode;
  }

  showHistoryMenu() {
    this.historyMenuVisible = true;
    document.body.classList.add('overflow');
  }

  closeHistoryMenu() {
    this.historyMenuVisible = false;
    document.body.classList.remove('overflow');
  }

  addPressedStyle(event) {
    if (this.isKiosk) {
      event.target.classList.add('pressed');
    }
  }

  removePressedStyle(event) {
    if (this.isKiosk) {
      event.target.classList.remove('pressed');
    }
  }

  created() {
    bus.$on('historyOpen', () => {
      this.historyMenuVisible = true;
    });
  }

  async openPage(item: LocalStorageServiceConfig.IHistoryItem) {
    if (item.type === this.itemTypes.FILM) {
      await this.$store.dispatch('routerStore/openFilmPage', item.id);
      document.body.classList.remove('overflow');
    }
    else if (item.type === this.itemTypes.KEYWORD) {
      localStorageService.pushHistory(
          {
            type: LocalStorageServiceConfig.HistoryItemTypes.KEYWORD,
            keyword: {
              entity_id: item.keyword.entity_id,
              keyword: item.keyword.keyword,
            },
          }
      );

      await this.$store.dispatch('rhizome/openRhizomeWithKeyword', {
        keyword: {
          id: Number(item.keyword.entity_id),
          value: item.keyword.keyword,
        }
      });
    }
  }

  @Watch('historyMenuVisible')
  getHistoryList() {
    if (this.historyMenuVisible) {
      this.historyList = localStorageService.getHistoryList();
    }

  }
}
